import type { IshikawaAreaConfig } from "./ishikawaConfig";
import type { ReasonType } from "./SQDCIshikawaDraft";

export type IshikawaCategoryMeta = {
  type: ReasonType;
  color: string;
  label: string;
};

const COLORS = [
  "var(--p-orange-500)",
  "var(--p-blue-500)",
  "var(--p-green-500)",
  "var(--p-purple-500)",
  "var(--p-teal-500)",
  "var(--p-red-500)",
  "var(--p-cyan-500)",
  "var(--p-pink-500)",
  "var(--p-indigo-500)",
  "var(--p-yellow-600)",
] as const;

export function getIshikawaCategories(areas: IshikawaAreaConfig[]): IshikawaCategoryMeta[] {
  return areas.map((area, index) => ({
    type: area.id,
    label: area.label,
    color: COLORS[index % COLORS.length]!,
  }));
}
